var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiGetOneClientRfp, apiUpdateClientViewRequest, } from '../../../../../actions/ClientRfpActions';
import { RFP_VIEW_REQUEST_STATUS_APPROVAL, RFP_VIEW_REQUEST_STATUS_DISAPPROVED, } from '../../../../../define/consts/rfp';
import { wrapDispatch, wrapNotifyError } from '../../../../../helpers/action';
/**
 * 閲覧申請の承認
 * @param id
 * @param dispatch
 * @returns {*}
 */
const useOnClick = (id, dispatch) => {
    const baseEvent = useCallback((e, updateValue) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            const { value } = e.currentTarget;
            const action = apiUpdateClientViewRequest(id, value, updateValue);
            yield wrapDispatch(dispatch, action);
            yield wrapDispatch(dispatch, apiGetOneClientRfp(id));
        }));
    }), [id, dispatch]);
    const onClickApprove = useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        e.stopPropagation();
        e.preventDefault();
        yield baseEvent(e, RFP_VIEW_REQUEST_STATUS_APPROVAL.value);
    }), [baseEvent]);
    const onClickDisApprove = useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        e.stopPropagation();
        e.preventDefault();
        yield baseEvent(e, RFP_VIEW_REQUEST_STATUS_DISAPPROVED.value);
    }), [baseEvent]);
    return {
        onClickApprove,
        onClickDisApprove,
    };
};
export const rfpViewRequestOrderUseCase = {
    useOnClick,
};
export default rfpViewRequestOrderUseCase;
